"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckStatus = void 0;
var CheckStatus;
(function (CheckStatus) {
    CheckStatus["ISSUE_OUTSTANDING"] = "I";
    CheckStatus["PAID_OR_RECONCILED"] = "R";
    CheckStatus["AVAILABLE_CHECK_CANCELLATION"] = "A";
    CheckStatus["UNAVAILABLE_CHECK_CANCELLATION"] = "U";
    CheckStatus["LIMITED_PAYABILITY_CANCELLATION"] = "L";
})(CheckStatus = exports.CheckStatus || (exports.CheckStatus = {}));
